import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
import { utcToDisplayDate, displayDateToUtc, displayDateToShortDate } from './../../common/formatting';

const MapSteps = (stepsDefinitions) => {
    let stepsDefinitionsMapped = [];
    _.forEach(stepsDefinitions, function (stepDef, key) {
        let stepAlreadyAdded = false;
        if (stepDef.mapToName !== undefined && stepDef.mapToName !== "")
            stepAlreadyAdded = _.find(stepsDefinitionsMapped, step => step.name === stepDef.mapToName) !== undefined;
        if (!stepAlreadyAdded)
            stepsDefinitionsMapped.push(stepDef);
    });
    return stepsDefinitionsMapped;
};

const MergeSteps = (visibleSteps, stepsDefinitions) => {
    let result = [];
    _.forEach(visibleSteps, function (stepDef, key) {
        let matchinStep = _.find(stepsDefinitions, step => step.status === stepDef.name);
        result.push(matchinStep !== undefined ? matchinStep : createEmptyStep(stepDef));
    });
    return result;
};

const createEmptyStep = (stepDefinition) => {
    return {
        status: stepDefinition.name,
        eventDateTime: ""
    };
}

const SortSteps = (stepsDefinitions, availableSteps) => {
    //First, create list of all steps that should be displayed(map steps if field "mapToName" exists)
    let visibleStepsList = MapSteps(stepsDefinitions);
    //Then merge visible steps with steps available(list of steps with known stauts. Does not contain "future" steps)    
    return MergeSteps(visibleStepsList, availableSteps);
}

const ProcessSteps = ({stepsList, stepsDefinitions, currentStepName, processStepsClass = 'col-xs-12 process-steps'}) => {

    let steps = _.isEmpty(stepsDefinitions) ? stepsList : SortSteps(stepsDefinitions, stepsList);
    return (
        <div className={processStepsClass}>
            <div className="process-row">
                {
                    steps.map((step, index) => {
                        let elementClass = classnames({
                            'btn btn-primary btn-circle step': true,
                            'circle-small': step.status !== currentStepName,
                            'circle-medium': step.status === currentStepName,
                            'active-step': step.status === currentStepName,
                            'no-date': step.eventDateTime === ""
                        });

                        let detailsClass = classnames({
                            'details': true,
                            'active-step': step.status === currentStepName,
                            'no-date': step.eventDateTime === ""
                        });

                        let displayName = _.isEmpty(stepsDefinitions) ? step.status : (_.find(stepsDefinitions, stepDef => stepDef.name === step.status)).displayName;
                        return (
                            <div className="process-step" key={index}>
                                <button disabled type="button" className={elementClass}></button>
                                <div className={detailsClass}>
                                    <div className="step-name">{displayName}</div>
                                    {step.eventDateTime !== "" &&
                                        <div className="date"> {utcToDisplayDate(step.eventDateTime)}</div>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
};

ProcessSteps.propTypes = {
};

const mapDispatchToProps = (dispatch, props) => ({
});

export default connect(null, mapDispatchToProps)(ProcessSteps);